var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "navbar position-absolute",
          class: { "navbar-mobile": _vm.$uiHelpers.isMobile }
        },
        [
          _c("b-navbar-brand", [
            _c("img", {
              staticClass: "navbar-brand-img",
              style: _vm.getLogoStyles,
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "outside-collapse" },
            [
              _c("lang-selector", {
                class: {
                  "flex-mobile-lang": _vm.$uiHelpers.isMobile,
                  "mr-4": !_vm.$uiHelpers.isMobile
                },
                attrs: { enablePortuguese: true }
              }),
              _vm._v(" "),
              _c(
                "b-nav-item",
                { staticClass: "my-auto d-none d-lg-block" },
                [
                  _c(
                    "base-button",
                    { attrs: { blue: "" }, on: { click: _vm.goToContactForm } },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$t("more-info-btn")))]),
                      _vm._v(" "),
                      _c("base-icon", {
                        staticClass: "ml-2",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                          color: "white"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "landing-cnt row" }, [
        _c("div", { staticClass: "bg-img" }),
        _vm._v(" "),
        _c("div", { staticClass: "main-block col" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("main-block-h1")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-cnt" },
            [
              _c(
                "base-button",
                {
                  attrs: { outline: "", blue: "" },
                  on: { click: _vm.goToContactForm }
                },
                [_vm._v(_vm._s(_vm.$t("more-info-btn")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "learn-more", on: { click: _vm.goToContactForm } },
          [_c("span", [_vm._v(_vm._s(_vm.$t("learn-more-btn")))])]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section py-lg-5 py-0", attrs: { id: "section-cero" } },
        [
          _c(
            "b-col",
            {
              staticClass: "my-auto content center-text",
              attrs: { cols: "12" }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "pr-lg-5 pr-sm-0",
                      attrs: { sm: "12", lg: "6" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "subtitle" },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("section-cero.subtitle")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              staticClass: "mt-2 mb-5 btn-all",
                              attrs: { outline: "", shadow: "" },
                              on: { click: _vm.goToMedicPsico }
                            },
                            [_vm._v(_vm._s(_vm.$t("section-cero.medicpsico")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "pr-lg-5 pr-sm-0",
                      attrs: { sm: "12", lg: "6" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "subtitle" },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("section-cero.subtitle-2")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              staticClass: "mt-2 mb-5 btn-all btn-ong",
                              attrs: { outline: "", shadow: "" },
                              on: { click: _vm.goToContactForm }
                            },
                            [_vm._v(_vm._s(_vm.$t("section-cero.ong")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$uiHelpers.isMobile
        ? _c(
            "b-row",
            {
              staticClass: "section py-lg-5 py-0",
              staticStyle: { "min-height": "50vh !important" },
              attrs: { id: "section-super-doctor-mobile" }
            },
            [
              _c(
                "b-col",
                { staticStyle: { "max-height": "50%", height: "50%" } },
                [_c("div", { staticClass: "col-bg ml-lg-auto" })]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section py-lg-5 py-0", attrs: { id: "section-one" } },
        [
          _c(
            "b-col",
            { staticClass: "my-auto content", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("section-one.title")))]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("section-one.subtitle")))])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "mt-5 btn-center",
                  attrs: { outline: "", shadow: "" },
                  on: { click: _vm.goToContactForm }
                },
                [_vm._v(_vm._s(_vm.$t("more-info")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "py-sm-0 py-lg-5", attrs: { md: "12", lg: "6" } },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert reverse-sm",
          attrs: { id: "section-two" }
        },
        [
          _c("b-col", { attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("section-two.title")))]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c(
                  "div",
                  { staticClass: "subtitle-list mt-5" },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "1" } },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "white"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "10", "offset-sm": "1" } },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("section-two.list.1")) +
                                  "\n                  "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "1" } },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "white"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "10", "offset-sm": "1" } },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("section-two.list.2")) +
                                  "\n                  "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "1" } },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "white"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "10", "offset-sm": "1" } },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("section-two.list.3")) +
                                  "\n                  "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "1" } },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "white"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "10", "offset-sm": "1" } },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("section-two.list.4")) +
                                  "\n                  "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5 d-flex justify-content-center" },
                      [
                        _c(
                          "base-button",
                          {
                            attrs: { white: "", outline: "" },
                            on: { click: _vm.goToContactForm }
                          },
                          [_vm._v(_vm._s(_vm.$t("colaborate-btn")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("opensalud4all-contact-form")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65449a03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65449a03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/opensalud/Opensalud4all.vue
// module id = 4241
// module chunks = 31